export const selectOptions = [
    { label: 'show', value: 'show' },
    { label: 'hide', value: 'hide' }
];
